import React from "react";
import firebase from "./Firebase/firebase";
import { useIdleTimer } from "react-idle-timer";
function IdleTimer({ props }) {

  const handleOnIdle = (event) => {
    console.log("user is idle", event);
    firebase.auth().signOut();
    localStorage.clear();
  };
  useIdleTimer({
    timeout: 1000 * 60 * 60 * 6,
    onIdle: handleOnIdle,
    debounce: 1000,
  });
  return <div></div>;

}
export default IdleTimer;
